export enum LicenseType {
  Basic,
  Premium,
  SmartLinksInfluencer, // deprecated
  SmartLinksArtist, // deprecated
  LostBasket,
  SmartLinksRookie, // deprecated
  Trial,
  Anniversary,
  Music24Basic,
  Music24Premium,
  Music24Pro,
  RatedApp,
}

export enum LicenseModelTransactionVendor {
  Unknown,
  Paddle,
  Apple,
  Google,
  OldLicense,
  ComputerBild,
  KomputerSwiat,
  StackCommerce,
  BT,
  InvitedBy,
  Amazon,
  Trial,
  LostBasket,
  Tidal,
  Resso,
  AppleSmartLinks,
  Setapp,
  Anniversary,
  AppleSK2,
  Stripe,
  RatedApp,
  // A free licence that an admin gave in the FYM admin (2026-10-21, `AdminLicenseGrantModel`). No
  // store and no payment. Append only: the column stores the number.
  AdminGrant,
}

export enum LicenseModelProductType {
  Unknown,
  OldSingleApp,
  OldBundle,
  SingleApp,
  SubscriptionYearly,
  SubscriptionQuarterly,
  SubscriptionLifeTime,
  SubscriptionFromReferral,
  SmartLinksInfluencer, // removed
  SmartLinksArtist, // removed
  SmartLinksTrial, // removed
  SmartLinksRookie, // removed
  Music24Basic,
  Music24Premium,
  Music24Pro,
  Music24NoLicense,
  Music24Trial,
  Music24ArtistPro,
  // The Plug plan (2026-10-13): Pro for one artist plus Outreach. Web only. Append only: the
  // column stores the number.
  Music24Plug,
  // FYM Premium Monthly (2026-10-17): a Stripe subscription billed every month, sold on the web.
  // Premium like Quarterly while the subscription is active. Append only: the column stores the
  // number.
  SubscriptionMonthly,
}

export const BasicLicenseModelProductTypes = [
  LicenseModelProductType.OldSingleApp,
  LicenseModelProductType.OldBundle,
  LicenseModelProductType.SingleApp,
];

export const PremiumLicenseModelProductTypes = [
  LicenseModelProductType.SubscriptionYearly,
  LicenseModelProductType.SubscriptionQuarterly,
  LicenseModelProductType.SubscriptionFromReferral,
  LicenseModelProductType.SubscriptionLifeTime,
  LicenseModelProductType.SubscriptionMonthly,
];
export enum LicenseRequestType {
  WEB,
  IAP,
}

export const nonChargingTransactionVendors = [
  LicenseModelTransactionVendor.ComputerBild,
  LicenseModelTransactionVendor.KomputerSwiat,
  LicenseModelTransactionVendor.StackCommerce,
  LicenseModelTransactionVendor.BT,
  LicenseModelTransactionVendor.InvitedBy,
  LicenseModelTransactionVendor.OldLicense,
  LicenseModelTransactionVendor.Trial,
  LicenseModelTransactionVendor.LostBasket,
  LicenseModelTransactionVendor.Tidal,
  LicenseModelTransactionVendor.Resso,
  LicenseModelTransactionVendor.Anniversary,
  LicenseModelTransactionVendor.RatedApp,
  LicenseModelTransactionVendor.AdminGrant,
];
export const LOST_BASKET_SONGS_LIMIT = 600;
export const RATED_APP_SONGS_LIMIT = 600;
export const BASE_SONGS_LIMIT = 300;
